import React, { useState } from 'react';

export default function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <style>
        {`
        
.pq-section.pq-style-1.text-center {
  text-align: center;
  margin-bottom: 40px;
}

.pq-section-sub-title {
  font-size: 18px;
  color: #666;
  display: block;
  margin-bottom: 10px;
}

.pq-section-title {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}


.pq-accordion-block {
  width: 100%;
}

.pq-accordion-box {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.pq-accordion-box.active {
  border-color: #239857;
}

.pq-ad-title {
  padding: 15px;
  background-color: #f9f9f9;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ad-title-text {
  font-size: 16px;
  color: #333;
  margin: 0;
  flex: 1;
}

.pq-accordion-details {
  padding: 0 15px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
}

.pq-accordion-details.open {
  padding: 15px;
  max-height: 500px; 
}

.pq-detail-text {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
  margin: 0;
}

.fa {
  font-size: 14px;
  color: #239857;
  transition: transform 0.3s ease;
}

.fa-chevron-down {
  transform: rotate(0deg);
}

.fa-chevron-up {
  transform: rotate(180deg);
}
.pq-accordion-block .pq-accordion-box .pq-accordion-details {
  padding: 0 20px  !important;
  border: 1px solid var(--grey-color);
  border-top: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}
`}
      </style>
      <section className="faq">
        <div className="container py-4">
          <div className="row">
            <div className="pq-section pq-style-1 text-center">
              <span className="pq-section-sub-title">FAQs</span>
              <h2 className="pq-section-title">Frequently Asked Question</h2>
            </div>
            
            <div className="col-xl-12 mt-xl-0 ps-xl-3">
              <div className="pq-accordion-block mt-4">
                {[ 
                  { question: "What is Sensorineural Hearing Loss?", answer: "Sensorineural hearing loss (SNHL) occurs when the inner ear (cochlea) or hearing nerve is damaged, making it difficult for sound signals to reach the brain. This type of hearing loss affects clarity rather than loudness, causing speech to sound muffled or distorted. SNHL is usually permanent, but early diagnosis and the right hearing solutions can greatly improve communication and quality of life." },
                  { question: "What are the symptoms of Sensorineural Hearing Loss?", answer: "Common symptoms include difficulty hearing conversations, especially in noisy places, needing others to repeat themselves, reduced speech clarity, muffled or distorted sounds, ringing in the ears (tinnitus), and gradually declining hearing. Some people may also experience sudden hearing loss. Recognising these symptoms early helps in getting proper evaluation and timely treatment." },
                  { question: "What causes Sensorineural Hearing Loss?", answer: "SNHL can be caused by aging, prolonged exposure to loud noise, hereditary factors, viral infections, sudden acoustic trauma, ear diseases, or certain medications that affect the inner ear. Conditions like Meniere’s disease or autoimmune disorders can also lead to SNHL. In many cases, the damage is permanent, which is why early assessment by an ENT specialist is important." },
                  {question: "How is Sensorineural Hearing Loss diagnosed?", answer: "Diagnosis involves a thorough medical history, ear examination, and advanced hearing tests like pure-tone audiometry, speech clarity tests, and tympanometry. If inner-ear or nerve damage is suspected, MRI or CT scans may be advised. These tests help determine the degree and type of hearing loss, allowing the doctor to recommend the best treatment or hearing solution."},
                  {question: "What is the best treatment for Sensorineural Hearing Loss?", answer: "Since SNHL is usually permanent, treatment focuses on improving hearing clarity and communication. Options include advanced digital hearing aids, cochlear implants for severe loss, tinnitus management, and lifestyle changes to protect remaining hearing. With early intervention and the right devices or therapy, most patients experience significant improvement in daily hearing function."}
                ].map((item, index) => (
                  <div className={`pq-accordion-box ${activeIndex === index ? 'active' : ''}`} key={index}>
                    <div className="pq-ad-title" onClick={() => toggleAccordion(index)}>
                      <h4 className="ad-title-text">
                        {item.question}
                        <i className={`fa ${activeIndex === index ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                      </h4>
                    </div>
                    <div className={`pq-accordion-details ${activeIndex === index ? 'open' : ''}`}>
                      <p className="pq-detail-text">{item.answer}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
